module.exports = __webpack_public_path__ + "img/envelope-open-fill.32735357.svg";